import {
  ModuleWithProviders,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';
import {
  translateInitializerFactory,
  TRANSLATE_CONFIG_TOKEN,
  TranslateConfig,
} from './types';
import { CommonTranslateService } from './translate.service';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from './translate.config.service';
import { buildInfo } from 'src/environments/build-info';

@NgModule({
  exports: [TranslateModule],
  imports: [TranslateModule.forRoot()],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    // ?v= : les fichiers i18n ne sont pas hashés, on force leur rechargement à chaque build
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: `.json?v=${encodeURIComponent(buildInfo.buildId)}`,
    }),
  ],
})
export class CommonTranslateModule {
  static forRoot(
    config: TranslateConfig,
  ): ModuleWithProviders<CommonTranslateModule> {
    return {
      ngModule: CommonTranslateModule,
      providers: [
        TranslateConfigService,
        { provide: TRANSLATE_CONFIG_TOKEN, useValue: config },
        provideAppInitializer(() => {
          const initializerFn = translateInitializerFactory(
            inject(TranslateConfigService),
            inject(TRANSLATE_CONFIG_TOKEN),
          );
          return initializerFn();
        }),
        TranslateService,
        CommonTranslateService,
      ],
    };
  }
}
